import { useMutation } from '@tanstack/react-query';
import { projectsAPI } from '@/services/designer/projects/projects.queries';

export const useProjectsBatchPublishMutation = () =>
    useMutation({
        mutationFn: async () => {
            const projects = await projectsAPI.getProjects();
            return Promise.all(
                projects.map(async (project) =>
                    projectsAPI.publishProject(project.id, {
                        version: project.version ?? '',
                        description: project.idn,
                        type: 'public'
                    })
                )
            );
        }
    });
